var _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHorizontal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 72,
    viewBox: "0 0 69 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 26,
    width: 19,
    height: 46,
    rx: 1,
    fill: "#75F76A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 46,
    width: 19,
    height: 26,
    rx: 1,
    fill: "#75F76A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    width: 19,
    height: 72,
    rx: 1,
    fill: "#75F76A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorizontal);
export default __webpack_public_path__ + "static/media/horizontal.cc9018f55c9e61c829f742064fca707a.svg";
export { ForwardRef as ReactComponent };